import { Box, SxProps, useTheme } from '@mui/material'
import React from 'react'
import { J2Forbidden } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  disabledIcon: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: theme.zIndex.appBar - 1,
    color: theme.palette.error.main,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(4),
      right: theme.spacing(1),
    },
  },
}))

interface Props {
  isDisabled?: boolean
  sxOverlay?: SxProps
  children?: React.ReactNode
  disabledIconStyle?: string
}

/**
 * Overlays a component with a grey drop and a 'forbidden' icon in case the system is not fully configured yet.
 */
const DisabledOverlay: React.FC<Props> = ({ sxOverlay, disabledIconStyle, children, isDisabled = false }) => {
  const { classes, cx } = useStyles()
  const theme = useTheme()

  const Overlay = (
    <>
      <J2Forbidden className={cx(classes.disabledIcon, disabledIconStyle)} />
      <Box
        sx={{
          position: 'absolute',
          height: '100%',
          width: '100%',
          borderRadius: 1,
          backgroundColor: 'rgba(175, 175, 175, 0.5)',
          zIndex: theme.zIndex.appBar - 2,
          top: 0,
          ...sxOverlay,
        }}
      />
    </>
  )

  return (
    <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
      {isDisabled && Overlay}
      {children}
    </Box>
  )
}

export default DisabledOverlay
